const contactToArr = (contactStr) => {
    if (!contactStr)
        return [];
    const contactArr = contactStr.split(';');
    let res = [];
    contactArr.forEach(item => {
        if (/^.*<.*>$/.test(item)) {
            res.push(item);
        }
        else {
            res.push(item);
        }
    });
    return res;
};
export const parseMailto = (url) => {
    try {
        const result = {
            to: [],
            cc: [],
            bcc: [],
            subject: '',
            body: '',
        };
        const mailtoUrl = new URL(url);
        result.to = contactToArr(mailtoUrl.pathname || '');
        const params = mailtoUrl.searchParams;
        result.cc = contactToArr(params.get('cc') || '');
        result.bcc = contactToArr(params.get('bcc') || '');
        result.subject = params.get('subject') || '';
        result.body = params.get('body') || '';
        if (result.body) {
            result.body = `<p style="font-family:Source Han Sans;font-size:14px;line-height:1.5;">${result.body}</p>`;
        }
        return {
            success: true,
            result,
        };
    }
    catch (error) {
        return {
            success: false,
        };
    }
};
